import { Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// Pages
import { LazyAdminPage, LazyHomePage, LazyPage404 } from '../pages/LazyPages.jsx';

// Components
import GlobalLoader from '../components/GlobalLoader/GlobalLoader.jsx';
import Layout from '../components/Layout/Layout.jsx';
import AdminRoute from '../components/admin/AdminRoute/AdminRoute';

// Routes
import { ROUTES } from './routes.js';

const getPage = LazyPage => (
  <Suspense fallback={<GlobalLoader />}>
    <LazyPage />
  </Suspense>
);

export const router = createBrowserRouter(
  [
    {
      element: <Layout />,
      errorElement: <LazyPage404 />,
      children: [
        {
          path: ROUTES.homePage.path,
          element: getPage(LazyHomePage),
        },
        {
          path: ROUTES.adminPage.path,
          element: <AdminRoute>{getPage(LazyAdminPage)}</AdminRoute>,
        },
      ],
    },
  ],
  {
    future: {
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_relativeSplatPath: true,
      v7_skipActionErrorRevalidation: true,
      v7_startTransition: true,
    },
  },
);
